import React, { useState, useEffect, useRef } from "react";
import { withRouter, useLocation } from "react-router-dom";
import { Layout, notification, Button } from "antd";
import { connect } from "react-redux";
import Header from "../../components/Header";
import Menu from "../../components/Menu";
import Modal from "../../components/Modal";
import loginApi from "@api/login";
import Inspectionnew from "@api/inspectionnew";
import queryString from "query-string";
import classnames from "classnames";
import { success } from "@store/actions/common";
import { MenuUnfoldOutlined, MenuFoldOutlined } from "@ant-design/icons";
import "./index.scss";

const { Content, Sider } = Layout;

const LayoutComponent = withRouter(
  ({ children, dispatch, history, userInfo }) => {
    const [collapsed, setCollapsed] = useState(false);
    const [visible, setVisible] = useState(false);
    const onCollapse = () => {
      setCollapsed(!collapsed);
    };
    const pathName = history.location.pathname;
    // 退出登录
    const _logout = () => {
      // dispatch(logout({id: userInfo.id}))
      loginApi.logout({ id: userInfo.id }).then((res) => {
        if (res.status == 0) {
          setVisible(false);
          sessionStorage.removeItem("userInfo");
          sessionStorage.removeItem("token");
          history.replace("/login");
        }
      });
    };
    useEffect(() => {
      document.querySelector(".ant-layout-content").scrollTo(0, 0);
      return () => {
        //cleanup
      };
    }, [location.hash]);

    useEffect(() => {
      const socket = new WebSocket(
        window.globalConfig.WebSocketMsg_URL +
          "?userId=" +
          userInfo.id +
          "&token=" +
          userInfo.token
      );
      socket.addEventListener("open", function () {
        console.log("链接成功");
      });
      socket.addEventListener("message", function (e) {
        const data = JSON.parse(e.data);
        const key = `open${Date.now()}`;
        notification.info({
          message: data.msgBody.msgTitle,
          description: data.msgBody.msgContent,
          placement: "topRight",
          duration: 7,
          key,
          btn: (
            <Button
              type="primary"
              size="small"
              onClick={() => updateReadStatus(data.msgBody.msgId, key)}
            >
              已读
            </Button>
          ),
        });
      });
    }, []);

    const updateReadStatus = (msgId, key) => {
      Inspectionnew.messageRead({ id: msgId }).then((res) => {
        notification.close(key);
      });
    };

    const showLogout = () => {
      setVisible(true);
    };

    const cancelOut = () => {
      setVisible(false);
    };
    // 地址链接，参数包含onlyCon，并且值为yes，不展示侧边栏和顶部信息(仅做演示用)
    const locationCopy = useLocation();
    const queryRef = useRef();
    queryRef.current = queryString.parse(locationCopy.search);
    useEffect(() => {
      if (queryRef.current.onlyCon == "yes") {
        sessionStorage.setItem("TENANT-ID", 45);
        sessionStorage.setItem("DATA-NODE", "dn1");
        let data = {
          id: "6",
          createBy: "1",
          createAt: "2020-12-22 16:17:48",
          updateBy: "0",
          updateAt: "2020-12-22 16:17:48",
          realName: "袁骁",
          name: "admin",
          roleLevel: 0,
          stationIds: "56",
          stations: "兴盛镇站",
          pwd: null,
          loginFlag: 1,
          tenantId: "45",
          tenantName: "九鼎瑞信",
          dataNode: null,
          token:
            "eyJhbGciOiJIUzI1NiJ9.eyJyZWFsTmFtZSI6IuiigemqgSIsInRlbmFudE5hbWUiOiLkuZ3pvI7nkZ7kv6EiLCJzdGF0aW9uSWRzIjoiNTYiLCJ0ZW5hbnRJZCI6IjQ1IiwibmFtZSI6ImFkbWluIiwiaWQiOiI2Iiwicm9sZUxldmVsIjoiMCIsInN0YXRpb25zIjoi5YW055ub6ZWH56uZIiwiZXhwIjoyMzAwNTU3MTEyfQ.KWn88TupFvR_JlQw1XafrP7HSx3OeHdPnSuTjKxNt2Y",
        };
        sessionStorage.setItem("userInfo", JSON.stringify(data));
        sessionStorage.setItem("token", data.token);
        dispatch(success(data));
      }
    }, []);

    return (
      <Layout
        className={classnames({
          "layout-wrap": true,
          "only-con": queryRef.current.onlyCon == "yes",
        })}
      >
        <Layout>
          {(!queryRef.current.onlyCon || queryRef.current.onlyCon != "yes") && (
            <Header
              history={history}
              showLogout={showLogout}
              collapsed={collapsed}
            ></Header>
          )}

          {(!queryRef.current.onlyCon || queryRef.current.onlyCon != "yes") &&
            React.createElement(
              collapsed ? MenuUnfoldOutlined : MenuFoldOutlined,
              {
                className: collapsed ? "menu-trigger on" : "menu-trigger",
                onClick: onCollapse,
              }
            )}
          {(!queryRef.current.onlyCon || queryRef.current.onlyCon != "yes") && (
            <Sider
              theme="light"
              className="side-menus-wrap"
              width={176}
              collapsedWidth={80}
              collapsible
              collapsed={collapsed}
              onCollapse={() => onCollapse()}
              trigger={null}
            >
              <Menu collapsed={collapsed} userInfo={userInfo} />
            </Sider>
          )}

          <Layout
            id="layout"
            style={
              pathName.includes("/stationManagement")
                ? { padding: "0", background: "#F5F5F5" }
                : { background: "#F5F5F5" }
            }
          >
            <Content style={{ minHeight: 280 }}>{children}</Content>
          </Layout>
        </Layout>
        {visible && (
          <Modal
            title="提出"
            visible={visible}
            onCancel={() => cancelOut()}
            onSubmit={() => _logout()}
          >
            <div>是否退出？</div>
          </Modal>
        )}
      </Layout>
    );
  }
);
const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};
export default connect(mapStateToProps)(LayoutComponent);
